import api from "./utils/api";
import { getAuthToken } from "./utils/tokens";
// FOR ADMIN ONLY ("CREATE A NEW CATEGORY")
const createCategory = async (name) => {
  try {
    const token = getAuthToken();
    const data = await api.post(
      "/categories",
      { name },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data.data;
  } catch (err) {
    throw err;
  }
};

const updateCategory = async (categoryId, name) => {
  try {
    const token = getAuthToken();
    const data = await api.put(
      `/categories/${categoryId}`,
      { name },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return data.data;
  } catch (err) {
    throw err;
  }
};

const deleteCategory = async (categoryId) => {
  try {
    const token = getAuthToken();
    const data = await api.delete(`/categories/${categoryId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return data.data;
  } catch (err) {
    throw err;
  }
};
// ****************
const getCategories = async () => {
  try {
    const data = await api.get("/categories");
    return data.data;
  } catch (err) {
    throw err;
  }
};

const getCategory = async (categoryId) => {
  try {
    const data = await api.get(`/categories/${categoryId}`);
    return data.data;
  } catch (err) {
    throw err;
  }
};

export {
  createCategory,
  getCategories,
  getCategory,
  updateCategory,
  deleteCategory,
};
